import { DefaultContainer } from '@/shared/ui';
import { MetaDecorator } from '@/shared/utils';
import { termsHTML } from './termsHTML';

const TermsPage = () => (
  <>
    <MetaDecorator
      description='meta.terms.description'
      title='meta.terms.title'
    />

    <DefaultContainer
      dangerouslySetInnerHTML={{
        __html: termsHTML,
      }}
    />
  </>
);

export default TermsPage;
